import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ noBackground?: boolean }>()(
  (theme, { noBackground }) => ({
    layout: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: noBackground
        ? 'transparent'
        : theme.palette.background.default,
    },
    contentWrapper: {
      flex: 1,
      overflow: 'auto',
    },
  })
)
